// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-year-dropdown {
    position: relative;
    font-family: "Poppins", sans-serif;
    font-weight: 600;
  }
  
  .custom-year-selected {
    padding: 2px;
    margin: 2px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    background-color: white;
    font-size: 14px;
    display: flex;
    align-items: center;
    gap: 6px;
    color:black
  }
  
  .custom-year-options {
    position: absolute;
    top: 110%;
    left: 0;
    max-height: 150px;
    overflow-y: auto;
    border: 0.5px solid black;
    border-radius: 4px;
    background-color: white;
    z-index: 10;
    width: 100%;
  }
  .custom-year-options::-webkit-scrollbar {
    display: none;
  }
  
  .custom-year-option {
    padding: 0px 10px;
    cursor: pointer;
  }
  
  .custom-year-option:hover,
  .custom-year-option.selected {
    background-color: #444444;
    color:white;
    margin:2px;
    border-radius: 2px;
  }`, "",{"version":3,"sources":["webpack://./src/features/order_client_details/components/client_calendar/calendar_year/calendarYearStyle.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,kCAAkC;IAClC,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR;EACF;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,uBAAuB;IACvB,WAAW;IACX,WAAW;EACb;EACA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;;IAEE,yBAAyB;IACzB,WAAW;IACX,UAAU;IACV,kBAAkB;EACpB","sourcesContent":[".custom-year-dropdown {\n    position: relative;\n    font-family: \"Poppins\", sans-serif;\n    font-weight: 600;\n  }\n  \n  .custom-year-selected {\n    padding: 2px;\n    margin: 2px;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    background-color: white;\n    font-size: 14px;\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    color:black\n  }\n  \n  .custom-year-options {\n    position: absolute;\n    top: 110%;\n    left: 0;\n    max-height: 150px;\n    overflow-y: auto;\n    border: 0.5px solid black;\n    border-radius: 4px;\n    background-color: white;\n    z-index: 10;\n    width: 100%;\n  }\n  .custom-year-options::-webkit-scrollbar {\n    display: none;\n  }\n  \n  .custom-year-option {\n    padding: 0px 10px;\n    cursor: pointer;\n  }\n  \n  .custom-year-option:hover,\n  .custom-year-option.selected {\n    background-color: #444444;\n    color:white;\n    margin:2px;\n    border-radius: 2px;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
